import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import { useForm } from 'react-hook-form';
import { Button, Form, Input } from '~/shared/components';
import { Grid } from '~/shared/components/Grid';
import { useValidationSchema } from '../../lib/useValidationSchema';
import { Fields, GiftCardFormFields } from '../../models/fields';
import { StyledGiftCardContainer } from './styled';
import { InputSpinner } from '~/shared/components/form/components/controllable-elements/input-element/styled';
import { useTranslation } from '~/shared/utils/translation';

type Props = {
    onSubmit: (data: GiftCardFormFields) => void;
    isLoading?: boolean;
};

export const GiftCardForm = ({ onSubmit, isLoading }: Props) => {
    const { translate } = useTranslation();
    const validationSchema = useValidationSchema();
    const methods = useForm<GiftCardFormFields>({
        mode: 'onBlur',
        reValidateMode: 'onBlur',
        resolver: yupResolver(validationSchema),
    });
    return (
        <StyledGiftCardContainer>
            <Form methods={methods} onSubmit={onSubmit}>
                <Grid flow="row">
                    <Input
                        name={Fields.CardNo}
                        label={translate('giftCardBalance.cardLabel')}
                        maxLength={19}
                    />
                    <Input
                        name={Fields.CVCNo}
                        label={translate('giftCardBalance.cvcLabel')}
                        maxLength={3}
                    />
                    <Button disabled={isLoading} style={{ marginTop: '24px' }}>
                        {translate('giftCardBalance.checkSaldo')}
                        {isLoading && <InputSpinner />}
                    </Button>
                </Grid>
            </Form>
        </StyledGiftCardContainer>
    );
};
